export default '';



// WEBPACK FOOTER //
// ./src/@utils/linkingUri/index.web.js